import './i18n';
import { useStore } from './helpers/use-store';

/**
 *
 */
export const AppTitle = () => {
  const { dataStore } = useStore();

  const { applicationConfigStore } = dataStore;

  return (
    <title>
      {applicationConfigStore.applicationTitle ||
        'Hub – Funded Accounts, Dashboard & Tools'}
    </title>
  );
};
